module.exports = __webpack_public_path__ + "static/logos-tiles-bar-s-6fe1c914c93b8da14a7fc97b8666c236.svg";